export default "__VITE_ASSET__CTgqQcS6__"